import React, { useEffect, useMemo, useState, useRef } from 'react';
import { connect } from 'react-redux';
import Breadcrumb from '../Common/Breadcrumb';
import { Divider, Tabs, Tab } from '@mui/material';
import { Actions as DASHBOARDACTIONS } from '../../store/actions/dashboardActions';
import { showLoader } from '../../store/action';
import { useHistory, useParams } from 'react-router-dom';
import { NoPermissions } from '../Common/ReusableComponents/Reusable';
import NetZeroTarget from './NetZeroTarget';
import IntensityTarget from './IntensityTarget';

const NetZero = ({ orgDetails, currentOrg, branding, orgTargets, netZero }) => {
  const { id } = useParams();
  const history = useHistory();
  const currentTarget = useMemo(() => {
    return (orgTargets && orgTargets.length > 0 && orgTargets?.find((target) => target.id === id)) || null;
  }, [orgTargets, id]);
  const [page, setPage] = useState(
    id === 'new'
      ? 'netzero'
      : currentTarget && currentTarget?.settingMethod === 'Absolute Contraction'
      ? 'netzero'
      : !currentTarget
      ? 'netzero'
      : 'intensity'
  );
  useEffect(() => {
    if (orgTargets && orgTargets.length > 0 && id !== 'new') {
      const target = orgTargets.find((target) => target.id === id);
      if (target) {
        setPage(target?.settingMethod === 'Absolute Contraction' ? 'netzero' : 'intensity');
      }
    }
  }, [orgTargets, id]);

  const prevOrg = useRef();
  const { primaryButton } = branding;

  useEffect(() => {
    if (currentOrg) {
      //Taking users back to the table page when switching orgs to avoid editing targets of another org
      if (id && prevOrg.current && currentOrg) {
        history.push('/netZero');
      }
      prevOrg.current = currentOrg;
    }
  }, [currentOrg, id]);

  if (!netZero) {
    return <NoPermissions />;
  }

  return (
    <React.Fragment>
      <Breadcrumb
        items={[
          { label: 'Science Based Targets', link: '/netZero' },
          { label: 'Target', link: `/netZero/${id}` },
        ]}
      />
      <div className='col-lg-12'>
        <section className='panel'>
          <div className='panel-body'>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: '10px' }}>
              <span className='SBT-title'>Science Based Targets</span>
            </div>
            <Divider />
            <div className='SBT-body' style={{ width: '100%' }}>
              <div style={{ display: 'flex', flexDirection: 'row', gap: '15px', justifyContent: 'center' }}>
                <Tabs
                  value={page}
                  onChange={(_, i) => setPage(i)}
                  style={{
                    padding: '8px 8px',
                    marginTop: '10px',
                    borderRadius: '8px',
                    border: '1px solid #ccc',
                  }}
                  variant='scrollable'
                  scrollButtons='none'
                  sx={{
                    minHeight: 0,
                    '& .MuiTabs-indicator': {
                      height: '100%',
                      borderRadius: '6px',
                      background: primaryButton,
                      boxShadow: '0 0 10px rgba(0, 0, 0, 0.3)',
                    },
                    '& .MuiTab-root:not(.Mui-selected)': {
                      '&:hover': {
                        backgroundColor: '#f1f1f1',
                        borderRadius: '6px',
                      },
                    },
                  }}>
                  <Tab
                    value={'netzero'}
                    label='Net Zero - Absolute'
                    disabled={id != 'new' && currentTarget?.settingMethod !== 'Absolute Contraction'}
                    sx={{
                      textTransform: 'none',
                      zIndex: 3,
                      fontSize: '14px',
                      color: '#555', // inactive text color
                      '&.Mui-selected': {
                        fontWeight: 550,
                        color: '#fff', // active text color
                      },
                      minHeight: 30,
                      px: 2,
                    }}></Tab>
                  <div
                    style={{
                      width: '1px',
                      height: '40px',
                      background: '#ccc',
                      margin: '0 12px',
                      alignSelf: 'center',
                    }}
                  />
                  <Tab
                    value={'intensity'}
                    label={'Net Zero - Intensity'}
                    disabled={id != 'new' && currentTarget?.settingMethod !== 'Physical intensity convergence'}
                    sx={{
                      textTransform: 'none',
                      zIndex: 3,
                      fontSize: '14px',
                      color: '#555', // inactive text color
                      '&.Mui-selected': {
                        color: '#fff', // active text color
                        fontWeight: 550,
                      },
                      minHeight: 36,
                    }}></Tab>
                </Tabs>
              </div>
              {page === 'netzero' ? <NetZeroTarget /> : <IntensityTarget />}
            </div>
          </div>
        </section>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const features = state?.features;
  const availableFeatures = state.organisation?.details?.features;
  const sbtFeature = features?.find((feature) => feature.featureKey === 'SCIENCE_BASED_TARGETS');
  const netZero = availableFeatures?.includes('SCIENCE_BASED_TARGETS') || sbtFeature?.enabledByDefault || false;
  return {
    orgDetails: state?.organisation?.details,
    currentOrg: state.currentOrganisation,
    branding: state?.branding?.colors,
    loader: state?.showLoader,
    orgTargets: state?.dashboard?.targets,
    netZero,
  };
};

const mapDispatchToProps = (dispatch) => ({
  sumValues: (data, year, org, dataType, ignoreCache) =>
    dispatch(DASHBOARDACTIONS.sumValues(data, year, org, dataType, ignoreCache)),
  saveTargets: (targets) => dispatch(DASHBOARDACTIONS.saveTargets(targets)),
  showLoader: (show) => dispatch(showLoader(show)),
  getTargets: () => dispatch(DASHBOARDACTIONS.getTargets()),
});

export default connect(mapStateToProps, mapDispatchToProps)(NetZero);
